// extracted by mini-css-extract-plugin
export var layoutContainer = "_d0-0";
export var layoutContainerNoRounding = "_d0-6";
export var layoutContainerOpen = "_d0-5";
export var layoutContainerResizing = "_d0-1";
export var mainContent = "_d0-2";
export var resizeDivider = "_d0-3";
export var slidePanel = "_d0-4";